import { getAdminRegion, hasStoreFeature, getCurrentStore } from '../constants/stores';

export const getClientCountry = (adminData) =>
  getAdminRegion(adminData) === 'india' ? 'India' : 'Qatar';

/** True when current store region is India (Clickncart). */
export const isIndiaClient = (adminData) => getAdminRegion(adminData) === 'india';

export { getAdminRegion, hasStoreFeature, getCurrentStore };
